module.exports = __webpack_public_path__ + "img/list-icon.0988ce37.svg";